/**
 * Messe-Shop24 – Link-Target-Guard
 * Eingebunden über snippets/ms-body-ende.liquid (MS-HOOK „Body-Ende“).
 *
 * Problem: Die Canopy-Option „Externe Links in neuem Tab öffnen“
 * (theme.settings.externalLinksNewTab, assets/main.js) setzt bei jedem Klick
 * target="_blank", wenn der Hostname des Links vom Shop abweicht. Pseudo-Links
 * ohne echtes Ziel (javascript:, #, leer) haben keinen Hostname und landen
 * dadurch fälschlich im neuen Tab – Folge: leerer Tab, z. B. beim
 * Judge.me-Button „Bewertung schreiben“ (setzt href="javascript:void(0)").
 *
 * Lösung: Listener in der Bubble-Phase auf window – läuft nach dem
 * Document-Handler von main.js und vor der Standardaktion des Browsers –
 * und entfernt target="_blank" bei Pseudo-Links wieder.
 * Echte externe Links bleiben unverändert.
 */
(function () {
  'use strict';

  var PSEUDO_HREF = /^(javascript:|#|$)/i;

  window.addEventListener('click', function (evt) {
    var link = evt.target instanceof Element
      ? evt.target.closest('a[target="_blank"]')
      : null;
    if (!link) return;

    var href = (link.getAttribute('href') || '').trim();
    if (PSEUDO_HREF.test(href)) {
      link.removeAttribute('target');
    }
  });
})();
